import React from "react";
import "./generic.scss";

import FairPlay from "./img/fair-play.png";
import Glo from "./img/glo.png";
import LuckyStrike from "./img/lucky-strike.png";
import PallMall from "./img/pall-mall.png";
import Vuse from "./img/vuse.png";
import VuseUltra from "./img/vuse-ultra.png";
import Luckies from "./img/luckies.png";
import LuckiesCrafted from "./img/luckies-crafted.png";

export default function BrandLogos({ brands }) {
  const logoMap = {
    glo: Glo,
    vuse: Vuse,
    "vuse-ultra": VuseUltra,
    "fair-play": FairPlay,
    "lucky-strike": LuckyStrike,
    "pall-mall": PallMall,
    luckies: Luckies,
    "luckies-crafted": LuckiesCrafted
  };
  return (
    <div className="brand-logos">
      <ul>
        {brands.map((item, i) => {
          return (
            <li key={i}>
              <img
                src={logoMap[item]}
                alt={`${item
                  .replace(/-/g, " ")
                  .replace(/\b\w/g, (l) => l.toUpperCase())} logo`}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
